import { Alert } from 'antd';
import { JOB_INTAKE_FIELD_LABELS, missingIntakeFields } from '../policies/job-intake-checklist.policy';
import type { JobDetail } from '../../../jobs.api';
import type { JobType } from '../../../../reference-data/reference-data.api';

/**
 * Intake-level completeness, shown inline rather than as a blocking validation error
 * (PRD → Job intake, requirement 5) — feeds the later dispatch readiness checklist, isn't
 * it. The attachment is the one item made visibly distinct: it's the evidence a disputed
 * rate is checked against later, and the gap between "created" and "attached" is real, not
 * just a UI state (see the plan's decisions) — so it must not read as a subtle, skippable badge.
 */
export function JobIntakeMissingItems({ job, jobTypes }: { job: JobDetail; jobTypes: JobType[] }) {
  const missing = missingIntakeFields(job, jobTypes);
  if (missing.length === 0) return null;

  const missingAttachment = missing.includes('attachment');
  const otherMissing = missing.filter((field) => field !== 'attachment');

  return (
    <div className="mb-5 flex flex-col gap-2">
      {missingAttachment && (
        <Alert
          type="warning"
          showIcon
          title="No original message attached yet"
          description="Attach the phone note, WhatsApp screenshot or release order below — it's the evidence if this rate is ever disputed."
        />
      )}
      {otherMissing.length > 0 && (
        <Alert type="info" showIcon title="Still missing" description={otherMissing.map((field) => JOB_INTAKE_FIELD_LABELS[field]).join(', ')} />
      )}
    </div>
  );
}
